module.exports = {"341282001":"东城","341282002":"西城","341282003":"颍南","341282100":"光武镇","341282101":"泉阳镇","341282102":"芦村镇","341282103":"新马集镇","341282104":"大黄镇","341282105":"田营镇","341282106":"陶庙镇","341282107":"王集镇","341282108":"砖集镇","341282109":"顾集镇","341282110":"代桥镇","341282111":"舒庄镇","341282200":"邴集乡","341282201":"靳寨乡","341282202":"任寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341282.json
// module id = 1129
// module chunks = 0